// extracted by mini-css-extract-plugin
export var menuItemRoot = "styles-module__menuItemRoot___Z7N0V";